import { useEffect, useMemo, useState } from "react"
import { useNavigate, useSearchParams } from "react-router-dom"
import { toast } from "react-toastify"

import { getMessageTemplatesOld, useEditMessageTemplateOldMutation } from "store/api/contractorsApi"
import { useAppSelector } from "store/hooks"
import { ApiTypes, UITypes } from "types"

import getErrorMessage from "utils/getErrorMessage"
import { MessageForm } from "components/form/MessageFormOld"

export const MessageTemplateEdit = () => {
  const [triggerEditMessageTemplate, { isLoading }] = useEditMessageTemplateOldMutation()
  const [currentTemplate, setCurrentTemplate] = useState<ApiTypes.Model.MessageTemplateOld | null>(null)
  const [searchParams] = useSearchParams()
  const templateId = searchParams.get("id")
  const selectMessageTemplates = useMemo(() => getMessageTemplatesOld.select(), [])
  const messageTemplates = useAppSelector(selectMessageTemplates)
  const navigate = useNavigate()

  const transformEditData = useMemo((): UITypes.MessageTemplate | undefined => {
    if (!currentTemplate) return undefined

    return {
      title: currentTemplate.title,
      message: currentTemplate.body,
      message_rich: currentTemplate.body_rich,
      frequency: currentTemplate.repeat_every,
    }
  }, [currentTemplate])

  const onSetCurrentTemplate = () => {
    const templatesList = messageTemplates?.data?.data
    if (!templateId || !templatesList?.length) {
      setCurrentTemplate(null)
    } else {
      const currentTemplate = templatesList.filter(item => item.id === Number(templateId))[0]
      setCurrentTemplate(currentTemplate)
    }
  }

  const onEditTemplate = async (data: UITypes.MessageTemplate) => {
    try {
      const res = await triggerEditMessageTemplate({
        body: {
          title: data.title,
          body: data.message,
          body_rich: data.message_rich || "",
          repeat_every: data.frequency as ApiTypes.Model.MessageTemplateFrequency,
        },
        id: templateId!,
      })
      const error = getErrorMessage(res?.error)

      if (error) {
        toast.error(error)
        return false
      } else {
        navigate("/messages/create-template")
        toast.success("Message template has been successfully updated!")
      }
    } catch (error) {
      console.error(error)
      return false
    }
  }

  useEffect(() => {
    onSetCurrentTemplate()
  }, [messageTemplates, templateId])

  return <MessageForm isLoading={isLoading} onSave={onEditTemplate} editableTemplate={transformEditData} />
}
